import { Market } from 'generated/event.types';
import { LanguageListPerMarket } from 'modules/events/basics/types/events.types';

export const languageListPerMarket: LanguageListPerMarket = {
  [Market.be]: [
    {
      id: 'en-GB',
      label: 'English',
    },
    {
      id: 'fr-BE',
      label: 'French',
    },
    {
      id: 'nl-BE',
      label: 'Dutch',
    },
  ],
  [Market.de]: [
    {
      id: 'de-DE',
      label: 'German',
    },
  ],
  [Market.com]: [
    {
      id: 'en-US',
      label: 'English',
    },
  ],
  [Market.fr]: [
    {
      id: 'fr-FR',
      label: 'French',
    },
  ],
  [Market.uk]: [
    {
      id: 'en-GB',
      label: 'English',
    },
  ],
  [Market.gb]: [
    {
      id: 'en-GB',
      label: 'English',
    },
  ],
  [Market.at]: [
    {
      id: 'de-AT',
      label: 'German',
    },
  ],
  [Market.au]: [
    {
      id: 'en-AU',
      label: 'English',
    },
  ],
  [Market.br]: [
    {
      id: 'pt-BR',
      label: 'Portugese',
    },
  ],
  [Market.ca]: [
    {
      id: 'en-CA',
      label: 'English',
    },
    {
      id: 'fr-CA',
      label: 'French',
    },
  ],
  [Market.es]: [
    {
      id: 'es-ES',
      label: 'Spanish',
    },
  ],
  [Market.ie]: [
    {
      id: 'en-IE',
      label: 'English',
    },
  ],
  [Market.jp]: [
    {
      id: 'ja-JP',
      label: 'Japanese',
    },
  ],
};
